module.exports = __webpack_public_path__ + "media/images/responsive/flow/resort_step_03-2a14e814baef15a196b7663da8069b76.jpg";